// Single source of truth for runtime configuration.
//
// Configuration is provided at runtime via window.__APP_CONFIG, which is set by config.js.
// config.js is generated per-environment by gen-config.sh:
//   * local dev - script/server writes public/config.js
//   * Jenkins   - baked into the image at build time
//   * TeamCity  - generated at container startup (deploy-time)
// config.js is loaded via a <script> tag in index.html before the app bundle.

const appConfig = (typeof window !== 'undefined' && window.__APP_CONFIG) || {};

export const appVersion = `${appConfig.buildNumber}+${appConfig.commitHash}`;

export default appConfig;
